import { render, staticRenderFns } from "./AdditionalInputItems.vue?vue&type=template&id=42d7afee&scoped=true&"
import script from "./AdditionalInputItems.vue?vue&type=script&lang=ts&"
export * from "./AdditionalInputItems.vue?vue&type=script&lang=ts&"
import style0 from "./AdditionalInputItems.vue?vue&type=style&index=0&id=42d7afee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7afee",
  null
  
)

export default component.exports